/**
 * The tab icon: the DistribuAI symbol of distribuai.com (public/favicon.svg, .ico and the
 * apple-touch-icon, linked from index.html), orange on sales demos (the DEMO tag's colour,
 * public/*-demo.*). The demo flag comes with the tenant settings, which load before sign-in,
 * so the sign-in page shows the demo icon too.
 */
const ICONS: [selector: string, file: string, demoFile: string][] = [
    ['link[rel="icon"][type="image/svg+xml"]', 'favicon.svg', 'favicon-demo.svg'],
    ['link[rel="icon"][sizes]', 'favicon.ico', 'favicon-demo.ico'],
    ['link[rel="apple-touch-icon"]', 'apple-touch-icon.png', 'apple-touch-icon-demo.png'],
]

export function showFavicon(demo: boolean) {
    for (const [selector, file, demoFile] of ICONS) {
        const link = document.head.querySelector<HTMLLinkElement>(selector)
        const href = `${import.meta.env.BASE_URL}${demo ? demoFile : file}`
        if (link && link.getAttribute('href') !== href) link.setAttribute('href', href)
    }
}
